// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "#057676";
var _3 = "#434343";
var _4 = "teal";
export { _1 as "body", _2 as "darkTeal", _3 as "headline", _4 as "teal" }
